module.exports = __webpack_public_path__ + "static/gallery2-8f3c529e9cf660cbab02c72dab4ad9f0.jpeg";